import inputs from "../../../../../../components/inputs/inputConfigs/templateCategory";

const templateFields = (isSuperAdmin = false, isEditing = false) => ({
  groups: [
    {
      items: [
        {
          input: inputs.templateCategoryName,
          grid: { xs: 12 },
        },
        ...(isSuperAdmin && !isEditing
          ? [
              {
                input: inputs.scopeId,
                grid: { xs: 12 },
              },
            ]
          : []),
      ],
    },
  ],
});

export default templateFields;
